var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverviewInfo1 = function SvgOverviewInfo1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 31.6667C15.1743 31.6667 16.6667 30.1743 16.6667 28.3333C16.6667 26.4924 15.1743 25 13.3333 25C11.4924 25 10 26.4924 10 28.3333C10 30.1743 11.4924 31.6667 13.3333 31.6667Z",
    stroke: "var(--konflux-brand-primary)",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.6667C31.8409 31.6667 33.3333 30.1743 33.3333 28.3333C33.3333 26.4924 31.8409 25 30 25C28.159 25 26.6667 26.4924 26.6667 28.3333C26.6667 30.1743 28.159 31.6667 30 31.6667Z",
    stroke: "var(--konflux-brand-primary)",
    strokeWidth: 1.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 28.3333H25V10.6C25 10.2686 24.7314 10 24.4 10H1.66666",
    stroke: "var(--konflux-brand-primary)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41667 28.3333H5.6C5.26863 28.3333 5 28.0647 5 27.7333V19.1667",
    stroke: "var(--konflux-brand-primary)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33334 15L10 15",
    stroke: "var(--konflux-brand-primary)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H34.6101C34.8472 15 35.0621 15.1396 35.1584 15.3563L38.2816 22.3836C38.3157 22.4604 38.3333 22.5434 38.3333 22.6273V27.7333C38.3333 28.0647 38.0647 28.3333 37.7333 28.3333H34.1667",
    stroke: "var(--konflux-brand-primary)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.3333H26.6667",
    stroke: "var(--konflux-brand-primary)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgOverviewInfo1;